jQuery(document).ready(function () {

    const skeletonCard = `
     <div class="col-sm-4 col-xs-6 skeleton-card">
      <div class="product-item__skeleton">
       <div class="skeleton-img skeleton-shimmer-plp"></div>
       <div class="skeleton-bottom">
        <div class="skeleton-line skeleton-shimmer-plp skeleton-title"></div>
        <div class="skeleton-price-star-row">
         <div class="skeleton-line skeleton-shimmer-plp skeleton-price"></div>
         <div class="skeleton-line skeleton-shimmer-plp skeleton-stars"></div>
        </div>
        <div class="skeleton-line skeleton-shimmer-plp skeleton-swatches-row"></div>
       </div>
      </div>
     </div>`;
   
    function loadNextProductBatch() {
     const $loadButton = $('.fastor_ajax_load_button a');
     const nextPageUrl = $('.pagination a.next').attr('href');
   
     if (
      $loadButton.attr('data-processing') == '1' ||
      !nextPageUrl ||
      nextPageUrl === ''
     ) {
      return;
     }
   
     $loadButton.attr('data-processing', '1'); // Set loading state
     $('.product-grid .products-on-page').append(skeletonCard.repeat(12));
     $loadButton.trigger('click');
    }
   
    window.addEventListener('scroll', (event) => {
     // Infinity scroll functionality
     if (
      $('.fastor_ajax_load_button').hasClass('fastor_ajax_load_more_hidden')
     ) {
      const $sandbox = $('#sandbox');
      if ($sandbox.length === 0) return;
   
      const elementBottom = $sandbox.offset().top + $sandbox.outerHeight();
      const windowBottom = $(window).scrollTop() + $(window).height();
   
      // Add a threshold (1600px) for better UX - triggers slightly before reaching exact bottom
      if (elementBottom <= windowBottom + 1600) {
       loadNextProductBatch();
      }
     }
    });
   
    /*
     * Also fire the next batch when the bottom 300px of #sandbox is in the viewport
     * Independent of the scroll-position check above.
     * No persistent intersection observer: visibility is checked on demand, right when a
     * previous batch finishes loading.
     */
   
    const sandboxEl = document.querySelector('#sandbox');
    if (
     sandboxEl &&
     $('.fastor_ajax_load_button').hasClass('fastor_ajax_load_more_hidden')
    ) {
     const SANDBOX_BOTTOM_ZONE_PX = 300;
   
     function isSandboxBottomZoneInViewport() {
      const rect = sandboxEl.getBoundingClientRect();
      const zoneTop = rect.bottom - SANDBOX_BOTTOM_ZONE_PX;
      return zoneTop < window.innerHeight && rect.bottom > 0;
     }
   
     /*
      * Kick off the chain immediately if that zone is already visible on
      * load (e.g. a short collection page that never needs scrolling) —
      * otherwise nothing would ever trigger the first check below.
      */
   
     if (isSandboxBottomZoneInViewport()) {
      loadNextProductBatch();
     }
   
     const loadButtonEl = document.querySelector('.fastor_ajax_load_button a');
   
     if (loadButtonEl) {
      const dataProcessingObserver = new MutationObserver(() => {
       if (
        loadButtonEl.getAttribute('data-processing') === '0' &&
        isSandboxBottomZoneInViewport()
       ) {
        loadNextProductBatch();
       }
      });
   
      dataProcessingObserver.observe(loadButtonEl, {
       attributes: true,
       attributeFilter: ['data-processing'],
      });
     }
    }
   
    if ($('.pagination a.next').attr('href') === '') {
     $('.fastor_ajax_load_button').hide();
    } else {
     $('.fastor_ajax_load_button').show();
    }
   });
    